import React, { useState, useEffect } from "react";
import {
  Col,
  Row,
  Button,
  ListGroup,
  Image,
  Card,
  ListGroupItem,
} from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Message from "../components/Message";
import Loader from "../components/Loader";
import { PayPalButton } from "react-paypal-button-v2";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { getOrderDetails, orderPay, orderDeliver } from "../actions/orderActions";
import { ORDER_PAY_RESET, ORDER_DELIVER_RESET } from "../constants/orderConstants";


function OrderScreen() {
  const Params = useParams();
  const orderId = Params.id;

  const orderDetails = useSelector((state) => state.orderDetails);
  const { order, error, loading } = orderDetails;

  const OrderPay = useSelector((state) => state.orderPay);
  const { success:successPay, loading:loadingPay } = OrderPay;

  const OrderDeliver = useSelector((state) => state.orderDeliver);
  const { success:successDeliver, loading:loadingDeliver } = OrderDeliver;

  const userO = useSelector((state) => state.userLogin);
  const user = userO.user;

  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const [sdkReady , setSdkReady] = useState(false)
  const cart = useSelector((state) => state.cart);
  if (!loading && !error){
    order.itemsPrice = order.orders
    .reduce((acc, item) => acc + item.price * item.qty, 0)
    .toFixed(2);
  }
  
// AQEtYgszN4ljOXZf99grDDIRaqZGPrFPgcy1kycI6TLpZoHez-B26RM59R_PcLUqhhbb_6cBA6HmYad_

  const addPaypalScript = () => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    
    script.src = "https://www.paypal.com/sdk/js?client-id=AXUasFRI8GSdB3wuIFDgKHDx550uEW1E4nBcF4e_izleCLaLmHCRkqfki1K70a03jj72bZS2WYUC71o6&enable-funding=venmo&currency=USD"
    script.async = true
    script.onload = () => { 
      setSdkReady(true)
     }
     document.body.appendChild(script)
  }

  useEffect(() => {
    if(!user ){
      Navigate('/login')
    }

    if(!order || successPay || order._id !== Number(orderId) || successDeliver){
      dispatch({type:ORDER_DELIVER_RESET})
      dispatch({type:ORDER_PAY_RESET})
      dispatch(getOrderDetails(orderId))
    }else if(!order.isPaid){
      if(!window.paypal){
        addPaypalScript()
      }else{
        setSdkReady(true)
      }
    }
  }, [order, orderId, dispatch, successPay, successDeliver ]);
  
  const sucessPaymentHandler = (paymentResult) =>{
    console.log(paymentResult)
    dispatch(orderPay(orderId, paymentResult))
  }

  const deliverHandler = () =>{
    console.log('test')
    dispatch(orderDeliver(order))
  }

  return loading ? (<Loader/>) : error ? (<Message variant='danger'> {error} </Message>):
   (
    <div>
      <h1>Order {order._id}</h1>
      <Row>
        <Col md={8}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h2>Shipping</h2>
              <p><strong>Hi {order.user.name}</strong></p>
              <p><strong>Email: </strong><a href={`mailto:${order.user.email}`}>{order.user.email}</a></p>

              <p>
                <strong>
                  Shipping: {order.ShippingAddress.address},{" "}
                  {order.ShippingAddress.city},{"  "}
                  {order.ShippingAddress.postalCode},{" "}
                  {order.ShippingAddress.country}
                </strong>
              </p>
              {order.isDelivered ? (
                <Message variant='success'>Delivered on {order.deliveredAt}</Message>
              ):( <Message variant='warning'>Not Delivered </Message>)}
            </ListGroup.Item>
            <ListGroup.Item>
              <h2>Payment Method</h2>
              <p>
                <strong>Method: {order.paymentMethod}</strong>
              </p>
              {order.isPaid ? (
                <Message variant='success'>Paid on {order.paidAt}</Message>
              ):( <Message variant='warning'>Not Paid </Message>)}
            </ListGroup.Item>
            <ListGroup.Item>
              <h2>Order Items</h2>
              {order.orders.length === 0 ? (
                <Message variant="info">Your cart is empty</Message>
              ) : (
                <ListGroup>
                  {order.orders.map((item, index) => (
                    <ListGroup.Item key={index}>
                      <Row>
                        <Col md={1}>
                          <Image
                            src={item.image}
                            alt={item.name}
                            fluid
                            rounded
                          />
                        </Col>
                        <Col>
                          <Link to={`/product/${item.product}`}>
                            {item.name}
                          </Link>
                        </Col>
                        <Col md={4}>
                          {item.qty} X ${item.price} - $
                          {(item.qty * item.price).toFixed(2)}
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={4}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h2>Order Summary</h2>
            </ListGroup.Item>
            <ListGroup.Item>
              <Row>
                <Col>Item:</Col>
                <Col>${order.itemsPrice}</Col>
              </Row>
            </ListGroup.Item>
            <ListGroup.Item>
              <Row>
                <Col>Shipping:</Col>
                <Col>${order.shippingPrice}</Col>
              </Row>
            </ListGroup.Item>
            <ListGroup.Item>
              <Row>
                <Col>Tax:</Col>
                <Col>${order.taxPrice}</Col>
              </Row>
            </ListGroup.Item>
            <ListGroup.Item>
              <Row>
                <Col>Total:</Col>
                <Col>${order.totalPrice}</Col>
              </Row>
            </ListGroup.Item>
            {!order.isPaid && (
              <ListGroup.Item>
                {loadingPay && <Loader/>}

                {!sdkReady ? (
                  <Loader/>
                ): (
                  <PayPalButton
                    amount={order.totalPrice}
                    onSuccess={sucessPaymentHandler}/>
                )}
              </ListGroup.Item>
            )}
            {user && user.isAdmin && order.isPaid && !order.isDelivered && (
              <ListGroup.Item>
                {loadingDeliver && <Loader/>}
                <Button
                type="button"
                className='btn btn-block w-100'
                onClick={deliverHandler}
                >
                  Mark AS Delivered
                </Button>
              </ListGroup.Item>
            )}
            <ListGroup.Item>
              {error && <Message variant="danger">{error}</Message>}
            </ListGroup.Item>
          </ListGroup>
        </Col>
      </Row>
    </div>
  );
}

export default OrderScreen;
